import React, { useState, useEffect } from 'react';
import { useAppContext } from '../../context/AppContext';

// Function library (same as original)
const functionLibrary = [
  { name: "add", template: "add( , )", desc: "Addition" },
  { name: "sub", template: "sub( , )", desc: "Subtraction" },
  { name: "mul", template: "mul( , )", desc: "Multiplication" },
  { name: "div", template: "div( , )", desc: "Division" },
  { name: "pow", template: "pow( , )", desc: "Exponentiation" },
  { name: "neg", template: "neg( )", desc: "Negation" },
  { name: "sqrt", template: "sqrt( )", desc: "Square root" },
  { name: "diff", template: "diff( , )", desc: "Derivative" },
  { name: "integrate", template: "integrate( , )", desc: "Integral" },
  { name: "sum", template: "sum( , , , )", desc: "Summation" },
  { name: "limit", template: "limit( , , )", desc: "Limit" },
  { name: "sin", template: "sin( )", desc: "Sine" },
  { name: "cos", template: "cos( )", desc: "Cosine" },
  { name: "tan", template: "tan( )", desc: "Tangent" },
  { name: "exp", template: "exp( )", desc: "Exponential" },
  { name: "log", template: "log( )", desc: "Logarithm" },
  { name: "and", template: "and( , )", desc: "Logical AND" },
  { name: "or", template: "or( , )", desc: "Logical OR" },
  { name: "not", template: "not( )", desc: "Logical NOT" },
  { name: "implies", template: "implies( , )", desc: "Implication" },
  { name: "iff", template: "iff( , )", desc: "If and only if" },
  { name: "set", template: "set( , , )", desc: "Set" },
  { name: "empty", template: "empty()", desc: "Empty set" },
  { name: "in", template: "in( , )", desc: "Element of" },
  { name: "notin", template: "notin( , )", desc: "Not element of" },
  { name: "subset", template: "subset( , )", desc: "Subset" },
  { name: "psubset", template: "psubset( , )", desc: "Proper subset" },
  { name: "union", template: "union( , )", desc: "Union" },
  { name: "intersect", template: "intersect( , )", desc: "Intersection" },
  { name: "setdiff", template: "setdiff( , )", desc: "Set difference" },
  { name: "cartesian", template: "cartesian( , )", desc: "Cartesian product" },
  { name: "powerset", template: "powerset( )", desc: "Powerset" },
  { name: "vector", template: "vector( , )", desc: "Column vector" },
  { name: "covector", template: "covector( , )", desc: "Row vector" },
  { name: "matrix", template: "matrix(covector( , ), covector( , ))", desc: "Matrix" },
];

const FunctionBar = () => {
  const { dslInput, setDslInput } = useAppContext();
  const [searchTerm, setSearchTerm] = useState('');

  const insertSearchTerm = () => {
    if (searchTerm.trim()) {
      setDslInput(prev => prev + (prev ? '\n' : '') + searchTerm.trim());
      setSearchTerm(''); // Clear search after insertion
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      insertSearchTerm();
    }
  };

  return (
    <div className="function-bar-container">
      <div className="compact-search-container">
        <input 
          className="compact-function-search" 
          type="text" 
          placeholder="Quick insert..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        {searchTerm && (
          <button 
            className="insert-btn"
            onClick={insertSearchTerm}
            title="Insert text (Enter)"
          >
            +
          </button>
        )}
      </div>
    </div>
  );
};

export default FunctionBar;